import {
  createFileRoute,
  Outlet,
  redirect,
  useParams,
} from '@tanstack/react-router';
import i18n from 'i18next';
import { LanguageProvider } from '../contexts/LanguageContext';
import { formatLanguageToLocaleRegion } from '../utils/localeUtils';

export const Route = createFileRoute('/$locale')({
  beforeLoad: ({ params }) => {
    const supportedURLLocales = ['cs', 'sk', 'en'];
    if (!supportedURLLocales.includes(params.locale)) {
      // Fallback to default language if user provides unsupported locale
      throw redirect({
        to: '/$locale/smartbanking/dashboard',
        params: { locale: 'cs' },
      });
    }

    // Dynamically change language in i18next (use the full region e.g. cs-CZ)
    const fullLang = formatLanguageToLocaleRegion(params.locale);
    if (i18n.language !== fullLang) {
      i18n.changeLanguage(fullLang);
    }
  },
  component: LocaleLayout,
});

function LocaleLayout() {
  const { locale } = useParams({ from: Route.id });

  return (
    <LanguageProvider locale={locale}>
      <Outlet />
    </LanguageProvider>
  );
}
